import { render, staticRenderFns } from "./ThemeTwo.vue?vue&type=template&id=fac9c922&scoped=true"
import script from "./ThemeTwo.vue?vue&type=script&lang=js"
export * from "./ThemeTwo.vue?vue&type=script&lang=js"
import style0 from "./ThemeTwo.vue?vue&type=style&index=0&id=fac9c922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac9c922",
  null
  
)

export default component.exports